


@if (isLoggedIn$ | async) {
  <app-shell-navigation></app-shell-navigation>
}
<p-toast id="globaltoaster" [style]="{'white-space': 'pre-wrap','word-wrap': 'break-word ','-moz-white-space' : 'pre-wrap'}">
</p-toast>
